import {
  claimLitigationEditLease,
  listenToLitigationEditLease,
  releaseLitigationEditLease
} from "@/firebase/firestore";
import { useContentEditLease } from "@/composables/useContentEditLease";

export const useLitigationEditLease = ({ litigationId, adminId, adminName }) =>
  useContentEditLease({
    contentId: litigationId,
    adminId,
    adminName,
    contentLabel: "litigation",
    claimEditLease: claimLitigationEditLease,
    listenToEditLease: listenToLitigationEditLease,
    releaseEditLease: releaseLitigationEditLease
  });
